<template>
    <zk-search-form-inline :form="form" @search="$emit('search', form)">
        <el-form-item label="项目代码">
            <el-input v-model.trim="form.code" clearable></el-input>
        </el-form-item>
        <el-form-item label="项目名称">
            <el-input v-model.trim="form.name" clearable></el-input>
        </el-form-item>
    </zk-search-form-inline>
</template>

<script>
export default {
    data() {
        return {
            form: {}
        }
    }
}
</script>

